import React from "react";
import "./ScheduleComponent.sass"
import "../../common.sass"
import PropTypes from "prop-types";

export default function ScheduleComponent(props) {
    const {onChange, schedule} = props;

    return (
        <div className="ScheduleComponent-wrapper">
            <div className="ScheduleComponent-days">
                <div><span className="full">Пн</span><span className="phone">Понедельник</span></div>
                <div><span className="full">Вт</span><span className="phone">Вторник</span></div>
                <div><span className="full">Ср</span><span className="phone">Среда</span></div>
                <div><span className="full">Чт</span><span className="phone">Четверг</span></div>
                <div><span className="full">Пт</span><span className="phone">Пятница</span></div>
                <div><span className="full">Сб</span><span className="phone">Суббота</span></div>
                <div><span className="full">Вс</span><span className="phone">Воскресенье</span></div>
            </div>
            <div className="ScheduleComponent-times">
                <div>
                    <input type="time"
                           value={schedule.monday || ''}
                           onChange={(e) => onChange({monday: e.target.value})}/>
                </div>
                <div>
                    <input type="time"
                           value={schedule.tuesday || ''}
                           onChange={(e) => onChange({tuesday: e.target.value})}/>
                </div>
                <div>
                    <input type="time"
                           value={schedule.wednesday || ''}
                           onChange={(e) => onChange({wednesday: e.target.value})}/>
                </div>
                <div>
                    <input type="time"
                           value={schedule.thursday || ''}
                           onChange={(e) => onChange({thursday: e.target.value})}/>
                </div>
                <div>
                    <input type="time"
                           value={schedule.friday || ''}
                           onChange={(e) => onChange({friday: e.target.value})}/>
                </div>
                <div>
                    <input type="time"
                           value={schedule.saturday || ''}
                           onChange={(e) => onChange({saturday: e.target.value})}/>
                </div>
                <div>
                    <input type="time"
                           value={schedule.sunday || ''}
                           onChange={(e) => onChange({sunday: e.target.value})}/>
                </div>
            </div>
        </div>
    )
}

ScheduleComponent.propTypes = {
    onChange: PropTypes.func.isRequired,
    schedule: PropTypes.object.isRequired,
}